const CompletionPlugin = options => {
  return {
    queries: {
      getCompletionStatus(editor) {
        const structured = editor.value.document.nodes.count(
          node => node.type !== 'lineGroup' && node.type !== 'pageBreak'
        )
        const total = editor.value.document.nodes.count(
          node => node.text.trim() !== ''
        )

        return {
          percentage: total ? Math.round((structured / total) * 100) : 0,
          structured,
          total
        }
      }
    }
  }
}

export default CompletionPlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/CompletionPlugin.js